// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from './axios';

export const analyticsAPI = {
  // GET /api/budget/reports/totals/?date_from=&date_to=
  // Returns { total_income, total_expense, total_savings, total_transfers, net_balance }
  summary: (params) => api.get('/api/budget/reports/totals/', { params }),

  // GET /api/budget/reports/expense/forecast/?months=
  forecast: (params) => api.get('/api/budget/reports/expense/forecast/', { params }),

  // GET /api/budget/reports/expense/top-categories/?limit=&month=&year=
  topCategories: (params) =>
    api.get('/api/budget/reports/expense/top-categories/', { params }),

  // GET /api/budget/reports/expense/trend/?period=monthly|yearly
  monthlyTrend: (params) =>
    api.get('/api/budget/reports/expense/trend/', { params }),
};

export default analyticsAPI;
